module.exports = __webpack_public_path__ + "static/img/8.e906f75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/8.png
// module id = RdYS
// module chunks = 0